import "@optiaxiom/web-components";

export default function() {
  // Any initialization code can go here
}
